export const apiEndpoints = {
  'Activity Ethiccraft': `${process.env.REACT_APP_API_BASE_URL}/activity_ethiccraft/read`,
  'Activity Hexagon': `${process.env.REACT_APP_API_BASE_URL}/activity_hexagon/read`,
  'Activity Tiles': `${process.env.REACT_APP_API_BASE_URL}/activity_tiles/read`,
  'Alumni Ethiccraft': `${process.env.REACT_APP_API_BASE_URL}/alumni_ethiccraft/read`,
  'Blog': `${process.env.REACT_APP_API_BASE_URL}/blog/read`,
  'CA Queries': `${process.env.REACT_APP_API_BASE_URL}/ca_queries/read`,
  'Camp Ethiccraft': `${process.env.REACT_APP_API_BASE_URL}/camp_ethiccraft/read`,
  'Camp Highlights': `${process.env.REACT_APP_API_BASE_URL}/camp_highlights/read`,
  'Camp Memories': `${process.env.REACT_APP_API_BASE_URL}/camp_memories/read`,
  'Camp Reviews': `${process.env.REACT_APP_API_BASE_URL}/camp_reviews/read`,
  'Campus Ambassador': `${process.env.REACT_APP_API_BASE_URL}/campus_ambassador/read`,
  'Certificates': `${process.env.REACT_APP_API_BASE_URL}/certificates/read`,
  'Chapter Ethiccraft': `${process.env.REACT_APP_API_BASE_URL}/chapter_ethiccraft/read`,
  'College Chapters': `${process.env.REACT_APP_API_BASE_URL}/college_chapters/read`,
  'College Ethiccraft': `${process.env.REACT_APP_API_BASE_URL}/college_ethiccraft/read`,
  'College Events': `${process.env.REACT_APP_API_BASE_URL}/college_events/read`,
  'Event Bookings': `${process.env.REACT_APP_API_BASE_URL}/event_bookings/read`,
  'Events': `${process.env.REACT_APP_API_BASE_URL}/events/read`,
  'Excellence': `${process.env.REACT_APP_API_BASE_URL}/excellence/read`,
  'Explore': `${process.env.REACT_APP_API_BASE_URL}/explore/read`,
  'Faculty': `${process.env.REACT_APP_API_BASE_URL}/faculty/read`,
  'Gallery': `${process.env.REACT_APP_API_BASE_URL}/gallery/read`,
  'Latest Stories': `${process.env.REACT_APP_API_BASE_URL}/latest_stories/read`,
  'Product': `${process.env.REACT_APP_API_BASE_URL}/product/read`,
  "Polaroid_Collage": `${process.env.REACT_APP_API_BASE_URL}/polaroid_collage/read`,
  'Reports': `${process.env.REACT_APP_API_BASE_URL}/reports/read`,
  'Team': `${process.env.REACT_APP_API_BASE_URL}/team/read`,
  'Upcoming Events': `${process.env.REACT_APP_API_BASE_URL}/upcoming_events/read`,
  'User Profiles': `${process.env.REACT_APP_API_BASE_URL}/profile/read`,
  'Valumni': `${process.env.REACT_APP_API_BASE_URL}/valumni/read`
};

export const toggleEndpoints = {
  'Activity Ethiccraft': `${process.env.REACT_APP_API_BASE_URL}/activity_ethiccraft/toggleShown`,
  'Activity Hexagon': `${process.env.REACT_APP_API_BASE_URL}/activity_hexagon/toggleShown`,
  'Activity Tiles': `${process.env.REACT_APP_API_BASE_URL}/activity_tiles/toggleShown`,
  'Alumni Ethiccraft': `${process.env.REACT_APP_API_BASE_URL}/alumni_ethiccraft/toggleShown`,
  'Blog': `${process.env.REACT_APP_API_BASE_URL}/blog/toggleShown`,
  'CA Queries': `${process.env.REACT_APP_API_BASE_URL}/ca_queries/toggleShown`,
  'Camp Ethiccraft': `${process.env.REACT_APP_API_BASE_URL}/camp_ethiccraft/toggleShown`,
  'Camp Highlights': `${process.env.REACT_APP_API_BASE_URL}/camp_highlights/toggleShown`,
  'Camp Memories': `${process.env.REACT_APP_API_BASE_URL}/camp_memories/toggleShown`,
  'Camp Reviews': `${process.env.REACT_APP_API_BASE_URL}/camp_reviews/toggleShown`,
  // 'Campus Ambassador': `${process.env.REACT_APP_API_BASE_URL}/campus_ambassador/toggleShown`,
  'Certificates': `${process.env.REACT_APP_API_BASE_URL}/certificates/toggleShown`,
  'Chapter Ethiccraft': `${process.env.REACT_APP_API_BASE_URL}/chapter_ethiccraft/toggleShown`,
  'College Chapters': `${process.env.REACT_APP_API_BASE_URL}/college_chapters/toggleShown`,
  'College Ethiccraft': `${process.env.REACT_APP_API_BASE_URL}/college_ethiccraft/toggleShown`,
  'College Events': `${process.env.REACT_APP_API_BASE_URL}/college_events/toggleShown`,
  // 'Event Bookings': `${process.env.REACT_APP_API_BASE_URL}/event_bookings/toggleShown`,
  'Events': `${process.env.REACT_APP_API_BASE_URL}/events/toggleShown`,
  'Excellence': `${process.env.REACT_APP_API_BASE_URL}/excellence/toggleShown`,
  'Explore': `${process.env.REACT_APP_API_BASE_URL}/explore/toggleShown`,
  'Faculty': `${process.env.REACT_APP_API_BASE_URL}/faculty/toggleShown`,
  'Gallery': `${process.env.REACT_APP_API_BASE_URL}/gallery/toggleShown`,
  'Latest Stories': `${process.env.REACT_APP_API_BASE_URL}/latest_stories/toggleShown`,
  'Product': `${process.env.REACT_APP_API_BASE_URL}/product/toggleShown`,
  "Polaroid_Collage": `${process.env.REACT_APP_API_BASE_URL}/polaroid_collage/toggleShown`,
  'Reports': `${process.env.REACT_APP_API_BASE_URL}/reports/toggleShown`,
  'Team': `${process.env.REACT_APP_API_BASE_URL}/team/toggleShown`,
  'Upcoming Events': `${process.env.REACT_APP_API_BASE_URL}/upcoming_events/toggleShown`,
  // 'User Profiles': `${process.env.REACT_APP_API_BASE_URL}/user_profiles/toggleShown`,
  'Valumni': `${process.env.REACT_APP_API_BASE_URL}/valumni/toggleShown`
};

export const updateEndpoints = {
  // 'Activity Ethiccraft': `${process.env.REACT_APP_API_BASE_URL}/activity_ethiccraft/update_textfields`,
  // 'Activity Hexagon': `${process.env.REACT_APP_API_BASE_URL}/activity_hexagon/update_textfields`,
  // 'Activity Tiles': `${process.env.REACT_APP_API_BASE_URL}/activity_tiles/update_textfields`,
  // 'Alumni Ethiccraft': `${process.env.REACT_APP_API_BASE_URL}/alumni_ethiccraft/update_textfields`,
  'Blog': `${process.env.REACT_APP_API_BASE_URL}/blog/update_textfields`,
  'CA Queries': `${process.env.REACT_APP_API_BASE_URL}/ca_queries/update_textfields`,
  // 'Camp Ethiccraft': `${process.env.REACT_APP_API_BASE_URL}/camp_ethiccraft/update_textfields`,
  // 'Camp Highlights': `${process.env.REACT_APP_API_BASE_URL}/camp_highlights/update_textfields`,
  'Camp Memories': `${process.env.REACT_APP_API_BASE_URL}/camp_memories/update_textfields`,
  'Camp Reviews': `${process.env.REACT_APP_API_BASE_URL}/camp_reviews/update_textfields`,
  // 'Campus Ambassador': `${process.env.REACT_APP_API_BASE_URL}/campus_ambassador/update_textfields`,
  'Certificates': `${process.env.REACT_APP_API_BASE_URL}/certificates/update_textfields`,
  // 'Chapter Ethiccraft': `${process.env.REACT_APP_API_BASE_URL}/chapter_ethiccraft/update_textfields`,
  'College Chapters': `${process.env.REACT_APP_API_BASE_URL}/college_chapters/update_textfields`,
  'College Ethiccraft': `${process.env.REACT_APP_API_BASE_URL}/college_ethiccraft/update_textfields`,
  'College Events': `${process.env.REACT_APP_API_BASE_URL}/college_events/update_textfields`,
  // 'Event Bookings': `${process.env.REACT_APP_API_BASE_URL}/event_bookings/update_textfields`,
  'Events': `${process.env.REACT_APP_API_BASE_URL}/events/update_textfields`,
  // 'Excellence': `${process.env.REACT_APP_API_BASE_URL}/excellence/update_textfields`,
  'Explore': `${process.env.REACT_APP_API_BASE_URL}/explore/update_textfields`,
  'Faculty': `${process.env.REACT_APP_API_BASE_URL}/faculty/update_textfields`,
  // 'Gallery': `${process.env.REACT_APP_API_BASE_URL}/gallery/update_textfields`,
  'Latest Stories': `${process.env.REACT_APP_API_BASE_URL}/latest_stories/update_textfields`,
  'Product': `${process.env.REACT_APP_API_BASE_URL}/product/update_textfields`,
  "Polaroid_Collage": `${process.env.REACT_APP_API_BASE_URL}/polaroid_collage/update_textfields`,
  'Reports': `${process.env.REACT_APP_API_BASE_URL}/reports/update_textfields`,
  'Team': `${process.env.REACT_APP_API_BASE_URL}/team/update_textfields`,
  'Upcoming Events': `${process.env.REACT_APP_API_BASE_URL}/upcoming_events/update_textfields`,
  // 'User Profiles': `${process.env.REACT_APP_API_BASE_URL}/user_profiles/update_textfields`,
  'Valumni': `${process.env.REACT_APP_API_BASE_URL}/valumni/update_textfields`
};

export const updateImageEndpoints = {
  'Activity Ethiccraft': `${process.env.REACT_APP_API_BASE_URL}/activity_ethiccraft/update_images`,
  'Activity Hexagon': `${process.env.REACT_APP_API_BASE_URL}/activity_hexagon/update_images`,
  'Activity Tiles': `${process.env.REACT_APP_API_BASE_URL}/activity_tiles/update_images`,
  'Alumni Ethiccraft': `${process.env.REACT_APP_API_BASE_URL}/alumni_ethiccraft/update_images`,
  'Blog': `${process.env.REACT_APP_API_BASE_URL}/blog/update_images`,
  'CA Queries': `${process.env.REACT_APP_API_BASE_URL}/ca_queries/update_images`,
  'Camp Ethiccraft': `${process.env.REACT_APP_API_BASE_URL}/camp_ethiccraft/update_images`,
  'Camp Highlights': `${process.env.REACT_APP_API_BASE_URL}/camp_highlights/update_images`,
  'Camp Memories': `${process.env.REACT_APP_API_BASE_URL}/camp_memories/update_images`,
  'Camp Reviews': `${process.env.REACT_APP_API_BASE_URL}/camp_reviews/update_images`,
  // 'Campus Ambassador': `${process.env.REACT_APP_API_BASE_URL}/campus_ambassador/update_images`,
  // 'Certificates': `${process.env.REACT_APP_API_BASE_URL}/certificates/update_images`,
  'Chapter Ethiccraft': `${process.env.REACT_APP_API_BASE_URL}/chapter_ethiccraft/update_images`,
  'College Chapters': `${process.env.REACT_APP_API_BASE_URL}/college_chapters/update_images`,
  'College Ethiccraft': `${process.env.REACT_APP_API_BASE_URL}/college_ethiccraft/update_images`,
  'College Events': `${process.env.REACT_APP_API_BASE_URL}/college_events/update_images`,
  // 'Event Bookings': `${process.env.REACT_APP_API_BASE_URL}/event_bookings/update_images`,
  'Events': `${process.env.REACT_APP_API_BASE_URL}/events/update_images`,
  'Excellence': `${process.env.REACT_APP_API_BASE_URL}/excellence/update_images`,
  'Explore': `${process.env.REACT_APP_API_BASE_URL}/explore/update_images`,
  'Faculty': `${process.env.REACT_APP_API_BASE_URL}/faculty/update_images`,
  'Gallery': `${process.env.REACT_APP_API_BASE_URL}/gallery/update_images`,
  'Latest Stories': `${process.env.REACT_APP_API_BASE_URL}/latest_stories/update_images`,
  'Product': `${process.env.REACT_APP_API_BASE_URL}/product/update_images`,
  "Polaroid_Collage": `${process.env.REACT_APP_API_BASE_URL}/polaroid_collage/update_images`,
  // 'Reports': `${process.env.REACT_APP_API_BASE_URL}/reports/update_images`,
  'Team': `${process.env.REACT_APP_API_BASE_URL}/team/update_images`,
  'Upcoming Events': `${process.env.REACT_APP_API_BASE_URL}/upcoming_events/update_images`,
  // 'User Profiles': `${process.env.REACT_APP_API_BASE_URL}/user_profiles/update_images`,
  'Valumni': `${process.env.REACT_APP_API_BASE_URL}/valumni/update_images`
};

export const uploadEndpoints = {
  'Activity Ethiccraft': `${process.env.REACT_APP_API_BASE_URL}/activity_ethiccraft/upload`,
  'Activity Hexagon': `${process.env.REACT_APP_API_BASE_URL}/activity_hexagon/upload`,
  'Activity Tiles': `${process.env.REACT_APP_API_BASE_URL}/activity_tiles/upload`,
  'Alumni Ethiccraft': `${process.env.REACT_APP_API_BASE_URL}/alumni_ethiccraft/upload`,
  'Blog': `${process.env.REACT_APP_API_BASE_URL}/blog/upload`,
  'CA Queries': `${process.env.REACT_APP_API_BASE_URL}/ca_queries/upload`,
  'Camp Ethiccraft': `${process.env.REACT_APP_API_BASE_URL}/camp_ethiccraft/upload`,
  'Camp Highlights': `${process.env.REACT_APP_API_BASE_URL}/camp_highlights/upload`,
  'Camp Memories': `${process.env.REACT_APP_API_BASE_URL}/camp_memories/upload`,
  'Camp Reviews': `${process.env.REACT_APP_API_BASE_URL}/camp_reviews/upload`,
  // 'Campus Ambassador': `${process.env.REACT_APP_API_BASE_URL}/campus_ambassador/upload`,
  'Certificates': `${process.env.REACT_APP_API_BASE_URL}/certificates/upload_cert_zip`,
  'Chapter Ethiccraft': `${process.env.REACT_APP_API_BASE_URL}/chapter_ethiccraft/upload`,
  'College Chapters': `${process.env.REACT_APP_API_BASE_URL}/college_chapters/upload`,
  'College Ethiccraft': `${process.env.REACT_APP_API_BASE_URL}/college_ethiccraft/upload`,
  'College Events': `${process.env.REACT_APP_API_BASE_URL}/college_events/upload`,
  // 'Event Bookings': `${process.env.REACT_APP_API_BASE_URL}/event_bookings/upload`,
  'Events': `${process.env.REACT_APP_API_BASE_URL}/events/upload`,
  'Excellence': `${process.env.REACT_APP_API_BASE_URL}/excellence/upload`,
  'Explore': `${process.env.REACT_APP_API_BASE_URL}/explore/upload`,
  'Faculty': `${process.env.REACT_APP_API_BASE_URL}/faculty/upload`,
  'Gallery': `${process.env.REACT_APP_API_BASE_URL}/gallery/upload`,
  'Latest Stories': `${process.env.REACT_APP_API_BASE_URL}/latest_stories/upload`,
  'Product': `${process.env.REACT_APP_API_BASE_URL}/product/upload`,
  "Polaroid_Collage": `${process.env.REACT_APP_API_BASE_URL}/polaroid_collage/upload`,
  'Reports': `${process.env.REACT_APP_API_BASE_URL}/reports/upload`,
  'Team': `${process.env.REACT_APP_API_BASE_URL}/team/upload`,
  'Upcoming Events': `${process.env.REACT_APP_API_BASE_URL}/upcoming_events/upload`,
  // 'User Profiles': `${process.env.REACT_APP_API_BASE_URL}/user_profiles/upload`,
  'Valumni': `${process.env.REACT_APP_API_BASE_URL}/valumni/upload`
};

export const formsData = [
  {
    name: 'Activity Ethiccraft',
    description: 'Displays four key visuals as the leading section under the Activities tab, representing core Ethiccraft initiatives.'
  },
  {
    name: 'Activity Hexagon',
    description: 'Titled "Frames of Change", this section features image-based content under the Activities tab.'
  },
  {
    name: 'Activity Tiles',
    description: 'Showcases the "Lead – Serve – Transform" theme through visual tiles in the Activities tab.'
  },
  {
    name: 'Alumni Ethiccraft',
    description: 'Highlights our alumni network with a single featured image, located in the Valumni tab.'
  },
  {
    name: 'Blog',
    description: 'Publishes blog content under the “Voice of Ethiccraft” series, accessible from the Activities tab.'
  },
  // {
  //   name: 'CA Queries',
  //   description: 'Displays frequently asked questions from students regarding the Campus Ambassador program in a slider format.'
  // },
  {
    name: 'Camp Ethiccraft',
    description: 'Features a visual slider at the top of the Camps tab, presenting details of various Ethiccraft-organized camps.'
  },
  {
    name: 'Camp Highlights',
    description: 'An image slider within the Camps tab showcasing key moments from past Ethiccraft camps and tours.'
  },
  {
    name: 'Camp Memories',
    description: 'Presents a visual gallery of memories and moments captured during past Ethiccraft camps.'
  },
  {
    name: 'Camp Reviews',
    description: 'Displays testimonials and feedback from students who have attended Ethiccraft camps, featured in the Camps tab.'
  },
  {
    name: 'Campus Ambassador',
    description: 'Captures data from students applying to join the Campus Ambassador program through the Join Team form.'
  },
  {
    name: 'Certificates',
    description: 'Stores and manages digital certificates issued to participants across Ethiccraft events and activities.'
  },
  {
    name: 'Chapter Ethiccraft',
    description: 'Showcases Ethiccraft chapter teams across colleges through a visual section in the Chapters tab.'
  },
  {
    name: 'College Chapters',
    description: 'Provides comprehensive profiles and listings of all colleges participating in the Ethiccraft chapter network.'
  },
  // {
  //   name: 'College Ethiccraft',
  //   description: 'Displays the "About" section for a specific college within the Colleges tab.'
  // },
  {
    name: 'College Events',
    description: 'Features recent events conducted at individual colleges, shown in the Colleges tab.'
  },
  {
    name: 'Event Bookings',
    description: 'Captures and stores registration data and participant responses for upcoming events.'
  },
  // {
  //   name: 'Events',
  //   description: 'Highlights up to four recent events on the Home tab for general visitors.'
  // },
  {
    name: 'Excellence',
    description: 'Showcases Ethiccraft’s awards, world records, and major accomplishments on the Home tab.'
  },
  {
    name: 'Explore',
    description: 'Curates images and highlights of Ethiccraft initiatives across various college chapters, presented in the Home tab.'
  },
  {
    name: 'Faculty',
    description: 'Displays detailed profiles of faculty members, including designations and affiliations, in the About tab.'
  },
  {
    name: 'Gallery',
    description: 'Hosts a visual gallery of Ethiccraft images featured within the About tab.'
  },
  {
    name: 'Latest Stories',
    description: 'Publishes recent chapter updates and milestone stories in the Chapters tab.'
  },
  // {
  //   name: 'Product',
  //   description: 'Highlights a special featured fest with a customized design component on the Home tab.'
  // },
  {
    name: 'Polaroid_Collage',
    description: 'Highlights a special featured fest with a customized design component on the Home tab.'
  },
  {
    name: 'Reports',
    description: 'Contains downloadable PDF reports documenting completed events and their impact.'
  },
  {
    name: 'Team',
    description: 'Displays detailed information on centralized and college-specific team members across the organization.'
  },
  {
    name: 'Upcoming Events',
    description: 'Comprehensive management of future events including banners, registration forms, questions, and configurations.'
  },
  {
    name: 'User Profiles',
    description: 'Maintains individual user data including contact details, education, and skills for authenticated members.'
  },
  {
    name: 'Valumni',
    description: 'Houses records of verified alumni from the Ethiccraft community, including bios and images.'
  }
];

export const defaultStructure = {
  'Activity Ethiccraft': {
    image: '',
    isShown: '',
    created_at: ''
  },
  'Activity Hexagon': {
    image: '',
    isShown: '',
    created_at: ''
  },
  'Activity Tiles': {
    image: '',
    isShown: '',
    created_at: ''
  },
  'Alumni Ethiccraft': {
    image: '',
    isShown: '',
    created_at: ''
  },
  'Blog': {
    name: '',
    description: '',
    image: '',
    author: '',
    date: '',
    isShown: '',
    created_at: ''
  },
  'Campus Ambassador': {
    full_name: '',
    email: '',
    phone_number: '',
    additional_message: '',
    college: '',
    portfolio: '',
    created_at: ''
  },
  'Camp Ethiccraft': {
    image: '',
    isShown: '',
    created_at: ''
  },
  'Camp Highlights': {
    image: '',
    isShown: '',
    created_at: ''
  },
  'Camp Memories': {
    image: '',
    caption: '',
    isShown: '',
    created_at: ''
  },
  'Camp Reviews': {
    name: '',
    role: '',
    text: '',
    image: '',
    position: '',
    isShown: '',
    created_at: ''
  },
  'CA Queries': {
    query_no: '',
    title: '',
    description: '',
    image: '',
    created_at: '',
    isShown: ''
  },
  'Certificates': {
    user_id: '',
    event_id: '',
    certificate_path: '',
    isShown: '',
    created_at: ''
  },
  'Chapter Ethiccraft': {
    image: '',
    isShown: '',
    created_at: ''
  },
  'College Chapters': {
    title: '',
    university_name: '',
    image: '',
    details: '',
    visit_url: '',
    isShown: '',
    created_at: ''
  },
  'College Ethiccraft': {
    image: '',
    college: '',
    isShown: '',
    created_at: ''
  },
  'College Events': {
    name: '',
    description: '',
    image: '',
    college: '',
    venue: '',
    date: '',
    isShown: '',
    created_at: ''
  },
  'Events': {
    name: '',
    description: '',
    date: '',
    venue: '',
    image: '',
    isShown: '',
    created_at: ''
  },
  // 'Event Bookings': {
  //   event_id: '',
  //   email: '',
  //   user_name: '',
  //   booking_time: '',
  //   answer1: '',
  //   answer2: '',
  //   answer3: '',
  //   answer4: '',
  //   answer5: '',
  //   answer6: '',
  //   answer7: '',
  //   answer8: '',
  //   answer9: '',
  //   answer10: '',
  //   answer11: '',
  //   answer12: '',
  //   answer13: '',
  //   answer14: '',
  //   answer15: '',
  //   answer16: '',
  //   answer17: '',
  //   answer18: '',
  //   answer19: '',
  //   answer20: '',
  //   answer21: '',
  //   answer22: '',
  //   answer23: '',
  //   answer24: '',
  //   answer25: '',
  //   answer26: '',
  //   answer27: '',
  //   answer28: '',
  //   answer29: '',
  //   answer30: ''
  // },
  'Excellence': {
    image: '',
    isShown: '',
    created_at: ''
  },
  'Explore': {
    image: '',
    isShown: '',
    created_at: '',
    title: '',
    venue: ''
  },
  'Faculty': {
    faculty_name: '',
    faculty_designation: '',
    faculty_image: '',
    faculty_description: '',
    college: '',
    isShown: '',
    created_at: ''
  },
  'Gallery': {
    image: '',
    isShown: '',
    created_at: ''
  },
  'Latest Stories': {
    title: '',
    college: '',
    date: '',
    description: '',
    image: '',
    isShown: '',
    created_at: ''
  },
  // 'Product': {
  //   name: '',
  //   description: '',
  //   date: '',
  //   venue: '',
  //   image: '',
  //   isShown: '',
  //   created_at: ''
  // },
  "Polaroid_Collage": {
    caption: "",
    image: "",
    isShown: "",
    created_at: ""
  },
  'Reports': {
    report_date: '',
    event_name: '',
    pdf_link: '',
    area: '',
    isShown: '',
    created_at: ''
  },
  'Team': {
    name: '',
    designation: '',
    image: '',
    description: '',
    college: '',
    isShown: '',
    created_at: ''
  },
  'Upcoming Events': {
    name: '',
    description: '',
    date: '',
    venue: '',
    college: '',
    banner_image1: '',
    banner_image2: '',
    banner_image3: '',
    question1: '', question2: '', question3: '', question4: '', question5: '',
    question6: '', question7: '', question8: '', question9: '', question10: '',
    question11: '', question12: '', question13: '', question14: '', question15: '',
    question16: '', question17: '', question18: '', question19: '', question20: '',
    question21: '', question22: '', question23: '', question24: '', question25: '',
    question26: '', question27: '', question28: '', question29: '', question30: '',
    questionType1: '', questionType2: '', questionType3: '', questionType4: '', questionType5: '',
    questionType6: '', questionType7: '', questionType8: '', questionType9: '', questionType10: '',
    questionType11: '', questionType12: '', questionType13: '', questionType14: '', questionType15: '',
    questionType16: '', questionType17: '', questionType18: '', questionType19: '', questionType20: '',
    questionType21: '', questionType22: '', questionType23: '', questionType24: '', questionType25: '',
    questionType26: '', questionType27: '', questionType28: '', questionType29: '', questionType30: '',
    option1: '', option2: '', option3: '',
    whatsapp_link: '',
    qmand1: '', qmand2: '', qmand3: '', qmand4: '', qmand5: '',
    qmand6: '', qmand7: '', qmand8: '', qmand9: '', qmand10: '',
    qmand11: '', qmand12: '', qmand13: '', qmand14: '', qmand15: '',
    qmand16: '', qmand17: '', qmand18: '', qmand19: '', qmand20: '',
    qmand21: '', qmand22: '', qmand23: '', qmand24: '', qmand25: '',
    qmand26: '', qmand27: '', qmand28: '', qmand29: '', qmand30: '',
    isOpen: '',
    isShown: '',
    created_at: ''
  },
  // 'User Profiles': {
  //   user_id: '',
  //   full_name: '',
  //   email: '',
  //   phone_number: '',
  //   profile_image: '',
  //   gender: '',
  //   dob: '',
  //   blood_group: '',
  //   bio: '',
  //   college: '',
  //   department: '',
  //   year_of_study: '',
  //   skills: '',
  //   address: '',
  //   social_links: '',
  //   isShown: '',
  //   created_at: '',
  //   updated_at: ''
  // },
  'Valumni': {
    image: '',
    name: '',
    description: '',
    tags: '',
    isShown: '',
    created_at: ''
  }
};

export const extractDataArray = (data) => {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.data)) return data.data;
  return [];
};